import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { Router } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ConnectedRouter } from 'connected-react-router';

import { ModalProvider, ModalRoot } from 'components/core/ModalRoot.component';
import HISTORY from 'config/history.singleton';
import QUERY from 'config/query.singleton';
import STORE from 'config/store.singleton';
import { AccessProvider } from 'providers/Access.provider';
import { AppointmentMachineProvider } from 'providers/AppointmentMachineProvider.component';
import { DispatcherProvider } from 'providers/Dispatcher.provider';
import { GiltProvider } from 'providers/GILT.provider';
import { PaymentAuditProvider } from 'providers/PaymentAuditProvider.component';
import { PusherProvider } from 'providers/Pusher.provider';
import { SalonBasicInfoProvider } from 'providers/SalonBasicInfo.provider';
import { SelectorProvider } from 'providers/SelectorProvider.provider';
import { ThemeProvider } from 'providers/Theme.provider';

const Providers = ({ children }) => {
  // NOTE: start with all being just the children

  let all = <>{children}</>;

  // NOTE: every next line wrapping all is a wrapper around the previous wrapper

  // NOTE: keep this one the lowest (first), could be removed in the future
  all = (
    <ModalProvider>
      <ModalRoot />
      {all}
    </ModalProvider>
  );

  all = <PaymentAuditProvider>{all}</PaymentAuditProvider>;
  all = <GiltProvider>{all}</GiltProvider>;
  all = <AccessProvider>{all}</AccessProvider>;
  all = <ThemeProvider>{all}</ThemeProvider>;
  all = <PusherProvider>{all}</PusherProvider>;
  all = <SalonBasicInfoProvider>{all}</SalonBasicInfoProvider>;
  all = <SelectorProvider store={STORE}>{all}</SelectorProvider>;
  all = <DispatcherProvider store={STORE}>{all}</DispatcherProvider>;
  all = <ConnectedRouter history={HISTORY}>{all}</ConnectedRouter>;
  all = <AppointmentMachineProvider>{all}</AppointmentMachineProvider>;
  all = <ReduxProvider store={STORE}>{all}</ReduxProvider>;
  all = <Router history={HISTORY}>{all}</Router>;
  all = <QueryClientProvider client={QUERY}>{all}</QueryClientProvider>;

  // this can be only the children, or it can be a long chain of providers nested one inside the other
  return all;
};

export default Providers;
